export const getInputId = (name: string, scope = 'data') => `${scope}-${name}`.replace('.', '-');
